import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminEmailCampaignsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager />
    </PageContainer>
  );
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (search: Record<string, unknown>): { new?: true } =>
    search.new === true || search.new === "1" || search.new === "true" ? { new: true } : {},
  component: AdminEmailCampaignsPage,
});
